//
// Get sales plans settings (source : laravel config/plans.php
const configPlanSettings = window.config.planSettings

export default Object.freeze(configPlanSettings)
